<template>
  <div>
    <v-toolbar elevation="0">
      <v-text-field
          flat
          solo
          clearable
          prepend-icon="search"
          placeholder="Type something"
          v-model="opsitabletrx.search"
          hide-details
          class=""
      ></v-text-field>
      <v-spacer></v-spacer>
      <div class="mt-6">
        <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="opsitabletrx.awal"
                label="Tanggal Awal"
                prepend-icon="event"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="opsitabletrx.awal" @input="menu1 = false"></v-date-picker>
        </v-menu>
      </div>
      <div class="mt-6">
        <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="opsitabletrx.akhir"
                label="Tanggal Akhir"
                prepend-icon="event"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="opsitabletrx.akhir" @input="menu2 = false"></v-date-picker>
        </v-menu>
      </div>
      <v-btn small elevation="0" class="ml-2" color="primary" @click.native="refreshData">
        <v-icon dark>refresh</v-icon>Refresh
      </v-btn>
      <vue-blob-json-csv
          file-type="csv"
          file-name="mutasisaldo"
          :data="mutasisaldodownload">
        <v-btn small text class="primary ml-2"><v-icon class="mr-2">fa-file-excel-o</v-icon> Download</v-btn>
      </vue-blob-json-csv>
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
        dense
        :headers="headers"
        :search="opsitabletrx.search"
        :items="mutasisaldo"
        class="elevation-0"
        item-key="id"
        :options.sync="opsitabletrx"
        :server-items-length="totalmutasisaldo"
        :loading="loading"
        @update:options="refreshData">
      <template v-slot:item.mutasi="{ item }">
        <div  class="text-right">
          {{formatAngka(item.mutasi)}}
        </div>
      </template>
      <template v-slot:item.saldoakhir="{ item }">
        <div  class="text-right">
          {{formatAngka(item.saldoakhir)}}
        </div>
      </template>
      <template v-slot:item.waktu="{ item }">
        {{formatDate(item.waktu)}}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import Utils from '@/plugins/utils'

export default {
  name: 'MutasiSaldo',
  data: () => ({
    menu1: false,
    menu2: false,
    dateawal: moment().add(7, 'hours').toISOString().substr(0, 10),
    dateakhir: moment().add(7, 'hours').toISOString().substr(0, 10),
    opsitabletrx: {
      search: '',
      itemsPerPage: 10,
      page: 1,
      statustrx: '',
      sortBy: ['id'],
      awal: moment().add(7, 'hours').toISOString().substr(0, 10),
      akhir: moment().add(7, 'hours').toISOString().substr(0, 10)
    },
    headers: [
      {
        text: 'TrxId',
        value: 'id'
      },
      {
        text: 'Waktu',
        value: 'waktu'
      },
      {
        text: 'Keterangan',
        value: 'keterangan'
      },
      {
        text: 'Mutasi',
        value: 'mutasi',
        align: 'right'
      },
      {
        text: 'Saldo Akhir',
        value: 'saldoakhir',
        align: 'right'
      }
    ]
  }),
  mounted () {
  },
  computed: {
    ...mapState('SaldoStore', ['mutasisaldo', 'loading', 'totalmutasisaldo', 'paymenthistories', 'totalpaymenthistori', 'mutasisaldodownload'])
  },
  methods: {
    ...mapActions('SaldoStore', ['getMutasiSaldo', 'getPaymentHistories', 'getMutasiSaldoDownload']),
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    },
    formatAngka (val) {
      return Utils.formatAngka(val)
    },
    refreshData () {
      this.getMutasiSaldo(this.opsitabletrx)
      this.getMutasiSaldoDownload(this.opsitabletrx)
    }
  }
}
</script>

<style scoped>

</style>
